import React from 'react';
import styled from 'styled-components';
import {
  Title,
  Wrapper,
  Card
} from '../../../ChangeStudiesOption/info/components';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import IconStar2 from '../../../../../../../../assets/icons/IconStar2.svg';
import iconPing from '../../../../../../../../assets/icons/icon-pin.svg';
import { DatesForRecalcule } from './DatesForRecalcule';
import { ImgContainer } from './styled';
import Link from '@/presentation/reusables/Link';

const ProcedureInformationText = styled.div`
  ul {
    list-style: disc;
    margin-left: 24px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
  detail: any;
  url?: string;
}

const ProcedureInfoComponent = ({
  inRegister,
  detail,
  url
}: ProcedureInfoComponentProps) => (
  <>
    <WhiteContainer inRegister={inRegister}>
      <Wrapper>
        <Card>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <img
              src={IconStar2}
              alt="other"
              style={{ marginTop: '-2px', marginRight: '8px' }}
            />
            <span
              style={{
                fontSize: 14,
                width: '90%',
                marginLeft: 4,
                paddingRight: 12
              }}
            >
              Si deseas retirarte de uno o más cursos por algún conflicto
              académico, tenemos este trámite que puede ayudarte.
            </span>
          </div>
          <div>
            <ProcedureInformationText>
              <Title style={{ marginTop: '8px' }}>
                ¿Qué requisitos necesito?
              </Title>
              <ul>
                <li>Estar matriculado en el presente ciclo.</li>
                <li>No estar en algún proceso disciplinario.</li>
                <li>
                  No ser becario de Pronabec “Beca 18”. Para atender tu
                  solicitud solicita nuestro trámite{' '}
                  <Link
                    linkType="internal"
                    url={url}
                    linkName="Retiro de Asignatura - Becarios Pronabec."
                  />
                </li>
              </ul>
              <br />
              <Title>¿Hasta cuando puedo solicitar mi trámite?</Title>
              <DatesForRecalcule
                datesModule={detail?.datesModule || []}
                periodId={detail?.periodApplied[0]?.id}
              />
              <br />
              <div>
                <strong>¿Tienes dudas?</strong> visita nuestra página{' '}
                <Link
                  linkType="external"
                  url="https://info.utp.edu.pe/"
                  linkName="UTP+info"
                />{' '}
                donde podrás encontrar más información.
              </div>
              <br />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start'
                }}
              >
                <ImgContainer src={iconPing} alt="other" />
                <ul
                  style={{
                    color: '#1A055D'
                  }}
                >
                  <li>
                    Si no realizaste el pago hasta la medianoche, el trámite
                    será anulado.
                  </li>
                  <li>El pago puede demorar en procesarse hasta 30 minutos.</li>
                </ul>
              </div>
            </ProcedureInformationText>
          </div>
        </Card>
      </Wrapper>
    </WhiteContainer>
    <br />
    <WhiteContainer>
      <Wrapper>
        <Card>
          <Title>Pasos a seguir:</Title>
          <div>
            <ol
              style={{
                listStyleType: 'lower-aplha',
                marginLeft: '16px',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#161D1F'
              }}
            >
              <li>
                Registra tu solicitud escogiendo el curso o los cursos que
                deseas retirarte.
              </li>
              <li>Realiza el pago en nuestras opciones disponibles.</li>
            </ol>
          </div>
        </Card>
      </Wrapper>
    </WhiteContainer>
  </>
);
export { ProcedureInfoComponent };
